import Component from '../core/Component'

export default class Typewritter extends Component {

    constructor(element) {
        super(element);
        this.sentence = this.element.dataset.text;
        this.delay = 50;
        this.speed = 50;
        this.placeholderHeight;

        if (this.element.dataset.delay) {
            this.delay = parseInt(this.element.dataset.delay)
        }
        if (this.element.dataset.speed) {
            this.speed = parseInt(this.element.dataset.speed)
        }
    }

    prepare() {
        document.fonts.load('1rem "Muli"').then(() => {
            setTimeout(() => {
            
                this.placeholderHeight = this.element.scrollHeight
                this.keepHeight(this.placeholderHeight)
                this.printSentence(
                    this.element,
                    this.sentence,
                    this.speed
                );
            }, this.delay);

         })


    }

    keepHeight(height) {
        this.element.style.height = height + "px";
    }

    printSentence(id, sentence, speed) {
            var index = 0,
            timer = setInterval(function () {
                id.classList.add('typing')
                var char = sentence.charAt(index);
                if (char === '<') index = sentence.indexOf('>', index);
                id.innerHTML = sentence.substr(0, index);
                if (++index === sentence.length + 1) {
                    clearInterval(timer);
                    id.classList.remove('typing')
                }
            }, speed);
    }
}